import React from "react"
import Ajax from 'superagent'
import {Dialog, Button, Icon, Toptips} from "react-weui"
import { X } from "react-feather"
import PropTypes from "prop-types"

import './PhoneCodeModal.less'

const IconFromStatus = {
  loading: 'loading',
  success: 'success-no-circle',
  failed: 'cancel'
}

export default class PhoneCodeModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { 
      code: "",
      codeStatus: "",
      showResend: false
    }
  }

  sendVerification() {
    Ajax.post("/startVerification")
      .send({
        prefix: this.props.prefix,
        phone: this.props.phone
      })
      .then()
  }

  componentDidMount() {
    this.sendVerification()
  }

  render() {
    const { onClose } = this.props
    return  (
      <React.Fragment>
        <Dialog
          id="PhoneCodeModal"
          type="ios"
          show 
          style={{
            maxWidth: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
            width: window.matchMedia("(min-width: 735px)").matches ? "360px" : "90%",
            maxHeight: "95%",
            padding: "0.5vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <header>
            <X size="30px" onClick={() => onClose()} />
          </header>

          <section>
            <h2>注意:</h2>
            <p>已向指定电话号码发送了验证短信</p>
            <p>输入验证码以确认付款</p>
            <div className="codeWrapper">
              <input 
                type="number"
                disabled={this.state.codeStatus == 'success' || this.state.codeStatus == 'loading'}
                value={this.state.code}
                onChange={evt => {
                  /* #TODO posible condición de carrera si se lanzan dos peticiones y no vuelven en el mismo orden */
                  if (evt.target.value.length < 4) this.setState({codeStatus: ""}) 
                  if (evt.target.value.length <= 4) this.setState({code: evt.target.value}) 
                  if (evt.target.value.length == 4) {
                    this.setState({ codeStatus: "loading" })
                    Ajax.post("/checkVerification")
                      .send({
                        prefix: this.props.prefix,
                        phone: this.props.phone,
                        code: evt.target.value
                      })
                      .then((res) => { 
                        if (res.body.success) this.setState({codeStatus: "success"}) 
                        else this.setState({codeStatus: "failed"}) 
                      })
                  }
                }}
              />
              {this.state.codeStatus && <Icon value={IconFromStatus[this.state.codeStatus]}/>}
            </div>
            <Button
              className={`advanceButton ${this.state.codeStatus != 'success' ? 'disabled' : ""}`}
              disabled={this.state.codeStatus != 'success'}
              onClick={() => this.props.onSuccess()}
            >
              <p className="buttonText">下一步</p>
            </Button>
            {this.state.codeStatus != 'success' && (
              <p 
                className="resendsms"
                onClick={() => {
                  this.sendVerification()
                  this.setState({showResend: true})
                  setTimeout(() => this.setState({showResend: false}), 1500);
                }}
              >
                重新发送
              </p>
            )}
          </section>
        </Dialog>
        <Toptips type="warn" show={this.state.showResend}>信息已发送</Toptips>
      </React.Fragment>
      
    )
  }
}

PhoneCodeModal.propTypes = {
  menu: PropTypes.object.isRequired, 
  onClose: PropTypes.func, 
}


// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/components/PhoneCodeModal.jsx